<template lang="pug">

.fi-per-wrap
	span.fi-per__label {{ $t("Periods") }}
	.fi-per
		.fi-per__item(
			role="button"
			@click="setQuarter(0)"
			:class="{'fi-per__item--selected': isQuarterSelected(0)}"
		) {{ $t("All") }}

		.fi-per__item(
			v-for="quarter in 4"
			role="button"
			@click="(quarterNum>=quarter) ? setQuarter(quarter) : ''"
			:class="{'fi-per__item--selected': isQuarterSelected(quarter)&&(quarterNum>=quarter), 'fi-per__item--disabled': (quarterNum<quarter)}"
		) {{quarter}}{{ $t("Q") }}

		.fi-per__item(
			v-for="overtime in numOvertimes"
			:key="overtime"
			role="button"
			@click="setQuarter(4 + overtime)"
			:class="{'fi-per__item--selected': isQuarterSelected(4 + overtime)}"
		) {{ $t("OT") }}{{ overtime }}


</template>

<style lang="sass">

.fi
	&-per
		display: flex
		flex-direction: row
		font-weight: $bold
		font-size: 1.1em
		&-wrap
			display: flex
			flex-direction: column
			align-items: center
			align-self: end
			&--end
				+breakpoint(400px)
					justify-self: end
		&__item
			padding: 0 0.5em
			cursor: pointer
			white-space: nowrap
			&--selected
				color: $orange
				border-bottom: 2px solid $primary-color
			@media (hover: hover) and (pointer: fine)
				&:hover
					color: $orange
				
			&--disabled
				color: $grey
				font-weight: $regular
				@media (hover: hover) and (pointer: fine)
					&:hover
						color: $grey
						cursor: initial

</style>

<script>

export default {
	name:"NavQuarter",
	computed: {
		quarterNum() {
			return this.$store.state.match.quarterNum
		},
		numOvertimes() {
			let overtimes = this.quarterNum - 4
			if (overtimes > 0) {
				return this.quarterNum - 4
			} else {
				return []
			}
		}
	},
	methods:{
		isQuarterSelected(q) {
			return this.$store.state.match.selQuarter == q
		},
		setQuarter(q) {
			this.$store.commit('match/setQuarter',q)
		}
	}
}

</script>